export function dataUriToFile(dataURI, fileName) {
  const splitDataURI = dataURI.split(',');
  const byteString =
    splitDataURI[0].indexOf('base64') >= 0
      ? atob(splitDataURI[1])
      : decodeURI(splitDataURI[1]);
  const mimeString = splitDataURI[0].split(':')[1].split(';')[0];

  const ia = new Uint8Array(byteString?.length);
  for (let i = 0; i < byteString?.length; i++) ia[i] = byteString.charCodeAt(i);

  return new File([ia], fileName, {type: mimeString});
}

export const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const makeChunkyArray = (items, chunk) => {
  var i, j;
  const chunkedItems = [];
  for (i = 0, j = items?.length; i < j; i += chunk) {
    const arr = items.slice(i, i + chunk);
    chunkedItems.push(arr);
  }
  return chunkedItems;
};
